import { stateOptions } from '../constants';
import { ValidationResultT } from '../types';
import { poBoxPattern, postalCodePattern } from '../utils/string';

export const validateAddressLine1 = (
  isForSpouse = false,
) => (value: string): ValidationResultT => {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return isForSpouse
      ? "Enter your spouse's street address."
      : 'Enter your street address.';
  }

  if (poBoxPattern.test(trimmedValue)) {
    return isForSpouse
      ? "This address cannot be a P.O. Box. Enter your spouse's street address."
      : 'This address cannot be a P.O. Box. Enter your street address.';
  }

  return true;
};

export const validateCity = (
  isForSpouse = false,
) => (value: string): ValidationResultT => {
  if (value.trim()) {
    return true;
  }

  return isForSpouse ? "Enter your spouse's city." : 'Enter your city.';
};

export const validateState = (
  isForSpouse = false,
) => (value: string): ValidationResultT => {
  if (!value) {
    return isForSpouse ? "Select your spouse's state." : 'Select your state.';
  }

  if (stateOptions.some((option) => option.value === value)) {
    return true;
  }

  return isForSpouse ? "Select your spouse's state." : 'Select your state.';
};

export const validateZip = (
  isForSpouse = false,
) => (value: string): ValidationResultT => {
  if (postalCodePattern.test(value.trim())) {
    return true;
  }

  return isForSpouse ? "Enter your spouse's ZIP code." : 'Enter your ZIP code.';
};
